export default __webpack_public_path__ + "static/media/token-6.8f68139e.png";